import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dialog-user-availability',
  templateUrl: './bulkemail.component.html'
})
export class BulkEmailComponent {

  public form:FormGroup;
  public strDaysLong: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  public strDaysShort: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  public strTimesLong: string[] = ['Morning','Noon','Afternoon','Evening'];
  public strTimesShort: string[] = ['Morning','Noon','Afternoon','Evening'];
  public busy: boolean = false;

  constructor(private http: HttpClient, private dialogRef: MatDialogRef<BulkEmailComponent>, private fb: FormBuilder) {
    this.busy = true;
    this.http.get<{days:string, times:string, preferredContact: string}>('/api/getplayerdatetimeprefs').subscribe(
      (data:{days:string, times:string, preferredContact: string}) => {

        this.form = fb.group({
          days: new FormArray([
            new FormControl(data?.days == 'Any Day' || data?.days?.includes(this.strDaysShort[0])? true: false),   // sunday
            new FormControl(data?.days == 'Any Day' || data?.days?.includes(this.strDaysShort[1])? true: false),   // monday
            new FormControl(data?.days == 'Any Day' || data?.days?.includes(this.strDaysShort[2])? true: false),   // tuesday
            new FormControl(data?.days == 'Any Day' || data?.days?.includes(this.strDaysShort[3])? true: false),   // wed
            new FormControl(data?.days == 'Any Day' || data?.days?.includes(this.strDaysShort[4])? true: false),   // thurs
            new FormControl(data?.days == 'Any Day' || data?.days?.includes(this.strDaysShort[5])? true: false),   // friday
            new FormControl(data?.days == 'Any Day' || data?.days?.includes(this.strDaysShort[6])? true: false)   // saturday
          ], this.atLeastOneCheckboxCheckedValidator()),
          times: new FormArray([
            new FormControl(data?.times == 'Any Time' || data?.times?.includes(this.strTimesShort[0])? true: false),   // morning
            new FormControl(data?.times == 'Any Time' || data?.times?.includes(this.strTimesShort[1])? true: false),   // noon
            new FormControl(data?.times == 'Any Time' || data?.times?.includes(this.strTimesShort[2])? true: false),   // afternoon
            new FormControl(data?.times == 'Any Time' || data?.times?.includes(this.strTimesShort[3])? true: false),   // evening
          ], this.atLeastOneCheckboxCheckedValidator()),
          preferredContact: new FormControl(data?.preferredContact, Validators.required)
        }
      );
      this.busy = false;
    });
  }

  get days() {
    return this.form.get('days') as FormArray;
  }
  get times() {
    return this.form.get('times') as FormArray;
  }

  getDaysAsShortString(): any[] {
    var q = this.form.value.days
       .map((bFlag,i) => bFlag ? this.strDaysShort[i] : null)
       .filter(val => val != null)
    return q;
  }
  isAllDays(): boolean {
    var q = this.form.value.days
       .filter(val => !!val )
    return q.length == this.strDaysShort.length;
  }
  getTimeAsShortString(): any[] {
    var q = this.form.value.times
       .map((bFlag,i) => bFlag ? this.strTimesShort[i] : null)
       .filter(val => val != null)
    return q;
  }
  isAllTimes(): boolean {
    var q = this.form.value.times
       .filter(val => !!val )
    return q.length == this.strTimesShort.length;
  }

  public cancel(evt:any) {
    evt.preventDefault();
    this.dialogRef.close();
  }

  public atLeastOneCheckboxCheckedValidator(minRequired = 1): ValidatorFn {
    return function validate(formArray: AbstractControl) {
      if (formArray instanceof FormArray) {
        const checked = formArray.controls.filter(control => !!control.value ); // only keep true ones
        return checked.length < minRequired ? { requireCheckbox: true } : null;
      }
      return null;
    };
  }

  public save() {
    var q = {
      days: this.isAllDays() ? 'Any Day' : this.getDaysAsShortString().join(', '),
      times: this.isAllTimes() ? 'Any Time' : this.getTimeAsShortString().join(', '),
      preferredContact: this.form.value.preferredContact
    };
    this.dialogRef.close(q);
  }
}